function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        stroke: #000;\n        stroke-width: 1px;\n        fill-rule: evenodd;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M295,534l-7-1c-3.037-2.421-3.236-6.409-6-9-8.363-5.475-18.41-2.283-31-4,0.736-11.789-.311-15.164-5-23-0.707,9.283-.663,28.851-8,32,4.538-35.707,1.485-82.229,8-120q7-37.5,14-75l17,3q0.5-3,1-6c13.92,1.895,29.573-9.782,49-13l132,5c15.533,0.34,62.792,6.167,67,4,12.1,77.128,29.11,205.718-63,206-0.4-6.959-1.518-20.506-6-24l-20-3-18-11c-23.335-9.068-45.7.509-58,11-16.351-7.069-20.289,6.006-31,11l-11-2c-2.6,1.322-1.482,3.917-1,6q0.5,5.5,1,11h-2l-3,1-5-10-13,3Q295.5,530,295,534ZM259,377c-2.4,21.343-19.581,90.528-11,113Q253.5,433.506,259,377ZM246,491v0Z"
});

var SvgFHairstyleStraightMediumBackVector = function SvgFHairstyleStraightMediumBackVector(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f_hairstyle_straight_medium_back_vector",
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFHairstyleStraightMediumBackVector, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/f_hairstyle_straight_medium_back_vector.8bca5a2b.svg";
export { ForwardRef as ReactComponent };